import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useUtils from 'hooks/useUtils';

import useEditPage from 'hooks/useEditPage';
const AccountmasterEditPage = (props) => {
		const app = useApp();
	const utils = useUtils();
	// form validation schema
	const validationSchema = yup.object().shape({
		ac_code: yup.string().required().label($t('acCode')),
		ac_name: yup.string().nullable().label($t('acName')),
		ac_level: yup.string().nullable().label($t('acLevel')),
		ac_head: yup.string().nullable().label($t('acHead')),
		ac_group: yup.string().nullable().label($t('acGroup')),
		op_debit: yup.number().nullable().label($t('opDebit')),
		op_credit: yup.number().nullable().label($t('opCredit')),
		cash_bank: yup.array().min(1).label($t('cashBank')),
		ac_type: yup.string().nullable().label($t('acType'))
	});
	// form default values
	const formDefaultValues = {
		ac_code: utils.randomNum(4), 
		ac_name: '', 
		ac_level: '', 
		ac_head: '', 
		ac_group: '', 
		op_debit: '', 
		op_credit: '', 
		cash_bank: [], 
		ac_type: '', 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/accountmaster`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="AccountmasterEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('editAccount')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('acCode')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="ac_code"  onChange={formik.handleChange}  value={formik.values.ac_code}   label={$t('acCode')} type="text" placeholder={$t('enterAcCode')}        className={inputClassName(formik?.errors?.ac_code)} />
                                                <ErrorMessage name="ac_code" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('acName')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="ac_name"  onChange={formik.handleChange}  value={formik.values.ac_name}   label={$t('acName')} type="text" placeholder={$t('enterAcName')}        className={inputClassName(formik?.errors?.ac_name)} />
                                                <ErrorMessage name="ac_name" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('acLevel')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="ac_level"     optionLabel="label" optionValue="value" value={formik.values.ac_level} onChange={formik.handleChange} options={app.menus.acLevel} label={$t('acLevel')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.ac_level)}   />
                                                <ErrorMessage name="ac_level" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('acHead')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/ac_head_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="ac_head"     optionLabel="label" optionValue="value" value={formik.values.ac_head} onChange={formik.handleChange} options={response} label={$t('acHead')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.ac_head)}   />
                                                    <ErrorMessage name="ac_head" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('acGroup')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/ac_group_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="ac_group"     optionLabel="label" optionValue="value" value={formik.values.ac_group} onChange={formik.handleChange} options={response} label={$t('acGroup')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.ac_group)}   />
                                                    <ErrorMessage name="ac_group" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('opDebit')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="op_debit"  onChange={formik.handleChange}  value={formik.values.op_debit}   label={$t('opDebit')} type="number" placeholder={$t('enterOpDebit')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.op_debit)} />
                                                <ErrorMessage name="op_debit" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('opCredit')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="op_credit"  onChange={formik.handleChange}  value={formik.values.op_credit}   label={$t('opCredit')} type="number" placeholder={$t('enterOpCredit')}  min={0}  step={0.1}    className={inputClassName(formik?.errors?.op_credit)} />
                                                <ErrorMessage name="op_credit" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('cashBank')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                {
                                                app.menus.cashBank.map((option) => {
                                                return (
                                                <div key={option.value} className="field-checkbox">
                                                    <Checkbox inputId={option.value} name="cash_bank" value={option.value} onChange={formik.handleChange} checked={formik.values.cash_bank.includes(option.value)} className={inputClassName(formik?.errors?.cash_bank, '')} />
                                                    <label htmlFor={option.value}>{option.label}</label>
                                                </div>
                                                )
                                                })
                                                }
                                                <ErrorMessage name="cash_bank" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('acType')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="ac_type"     optionLabel="label" optionValue="value" value={formik.values.ac_type} onChange={formik.handleChange} options={app.menus.acType} label={$t('acType')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.ac_type)}   />
                                                <ErrorMessage name="ac_type" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label={$t('update')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
AccountmasterEditPage.defaultProps = {
	primaryKey: 'ac_code',
	pageName: 'accountmaster',
	apiPath: 'accountmaster/edit',
	routeName: 'accountmasteredit',
	submitButtonLabel: $t('update'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('updateRecord'),
	msgAfterSave: $t('recordUpdatedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default AccountmasterEditPage;
